<template>
<el-dialog :visible.sync="showSummary" :close-on-click-modal="false" :before-close="handleClose" width="700px"
  title="填写小结">
  <div>
    <el-form ref="conclusionForm" :model="conclusionForm" label-width="100px">    
      <el-form-item label="小结内容：" prop="name">
        <wangeditorNew v-if="isCheck && isEdit" :formData="conclusionForm" :index="1000" :isCheck="isCheck" @content="contentChange" style="width: calc(100% - 46px);"></wangeditorNew>
        <div v-else v-html="conclusionForm.content"></div>
      </el-form-item>
    </el-form>
  </div>
  <div v-if="isEdit" style="text-align:center;margin-top:20px">
    <el-button size="small" @click="handleCancel">取消</el-button>
    <el-button size="small" type="primary" @click="handleSave">保存</el-button>
  </div>
  <div v-if="!isEdit && selectRecordRow.synergyConclusion && !selectRecordRow.conclusionSent" style="text-align:center;margin-top:20px">
    <el-button size="small" @click="handleEdit">编辑</el-button>
    <el-button size="small" type="primary" @click="handleSubmit">发送至房间</el-button>
  </div>
  <div v-if="selectRecordRow.conclusionSent" style="text-align:center;margin-top:20px">
    <el-button size="small" type="primary" disabled>已发送</el-button>
  </div>
</el-dialog>
</template>
<script>
import { DEEP_CLONE } from "@/utils/constants";
import { saveSynergyConclusion,sendSynergyConclusion } from "@/api/consultationCooperate"
import wangeditorNew from '@/components/wangeditorNew/index.vue'
export default {
  props: {
    showSummary: {
      type: Boolean,
      default: false
    },
    selectRecordRow: {
      type: Object
    }
  },
  components: {
    wangeditorNew
  },
  data() {
    return {
      isEdit: false,
      isCheck: true,
      conclusionForm: {
        content:''
      }
    }
  },
  async created() {
    // 1已发送0未发送
    // this.isEdit = this.selectRecordRow.conclusionSent ? false : true
    // 填写
    if (!this.selectRecordRow.synergyConclusion) {
      this.isEdit = true
    }
    // 已发送
    if (this.selectRecordRow.conclusionSent) {
      this.isEdit = false
    }
    // 已填写未发送
    if (this.selectRecordRow.synergyConclusion && !this.selectRecordRow.conclusionSent) {
      this.isEdit = false
    }
    this.conclusionForm.content = DEEP_CLONE(this.selectRecordRow).synergyConclusion
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.$emit('update:showSummary', false)
    },
    async handleSave() {
      let res = await saveSynergyConclusion({
        synergyId: this.selectRecordRow.id,
        synergyConclusion: this.conclusionForm.content
      })
      if (res.code == 0) {
        this.$message.success('保存成功')
        this.$emit('update:showSummary', false)
        this.$parent.getList()
      }
    },
    handleEdit() {
      this.isEdit = true
    },
    async handleSubmit() {
      let res = await sendSynergyConclusion({
        synergyId: this.selectRecordRow.id
      })
      if (res.code == 0) {
        this.$message.success('发送成功')
        this.$emit('update:showSummary', false)
        this.$parent.getList()
      }
    },
    contentChange(content) {
      this.conclusionForm.content = content.content
    },
    handleClose() {
      this.$emit('update:showSummary', false)
    }
  }
};
</script>
<style lang="less" scoped>

</style>